import React from "react";
import AboutUs from "./components/aboutUs/AboutUs";
import Footer from "./components/footer/Footer";
import ExampleCode from "./components/header/ExampleCode";
import Header from "./components/header/Header";
import Resources from "./components/resources/Resources";

const Prime = () => {
  return (
    <div>
      <Header />
      <AboutUs />
      <ExampleCode />
      <Resources />
      <Footer />
    </div>
  );
};

export default Prime;
